import { Button, Container, Stack } from "@mui/material";
import React from "react";
import { TypeCamaras } from "../camaras/interface/camara.interface";
import { useLocation, useNavigate } from "react-router-dom";
import { GraficoComponent } from "../../components/Grafico";
import { TypeFrigorficos, TypePlantas } from "../home/interace/frigorifico.interface";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

export const GraficosPage: React.FC = () => {

  const navigate = useNavigate();

  const graficoData = useLocation();

  //Si los parametros son null o no existem vuelve a home
  React.useEffect(() => {
    if (!graficoData.state) {
      navigate('/');
    }
  }, [graficoData, navigate]);

  const camara: TypeCamaras | undefined = graficoData.state?.propsCamara;
  const frio: TypeFrigorficos | undefined = graficoData.state?.propsFrio;
  const planta: TypePlantas | undefined = graficoData.state?.propsPlanta;

  // 🔹 Si no hay datos aún, no renderiza nada
  if (!graficoData.state) {
    return <></>;
  }

return (
  <Container 
    maxWidth={false} 
    sx={{
      px: 2, // padding horizontal: 2*8px = 16px
    }}
  > 
  {/*<Container maxWidth="xl">*/}
      <Stack sx={{my: 2}} spacing={2} direction="row">

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/")}
          startIcon={<KeyboardDoubleArrowLeftIcon />} 
        >
          PLANTAS
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/frigorificos", { state: planta })}
          startIcon={<KeyboardDoubleArrowLeftIcon />} 
        >
          SECTORES
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/camaras",{state: {planta, frio}})}
          startIcon={<NavigateBeforeIcon />} 
        >
          VOLVER
        </Button>
      </Stack>  
    <>
      <div>
        {
          <GraficoComponent propsCamara={camara!} />
        }
      </div>
    </>
  </Container>
  )
}